<template>
    <Introduction :url="''" :class="'introduction-chardon'">  
        <template #title>
            Atelier Chardon Savar
        </template>
        <template #speciality>
            Fashion & Design
        </template>
        <template #min-duration>
            От 2 года
        </template>
        <template #cost>
            От 2500 евро/год 
        </template>
        <template #campus>
            Париж, Нант и Берлин
        </template>
    </Introduction>  
</template>
<script>
import Introduction from '@/components/schools/slots/Introduction.vue'
export default {
    components:{
        Introduction
    }
}
</script>